var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logCell"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content",class:_vm.contentClass},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }